export const locationInfo = {
    USA: {
      datacenter: "New York, USA",
      latency: "Low latency for North America",
      compliance: "SOC 2 Type II Certified",
      network: "Tier-1 Network Providers"
    },
    Singapore: {
      datacenter: "Singapore, APAC",
      latency: "Optimized for Asia-Pacific",
      compliance: "ISO 27001 Certified",
      network: "Premium Asian Network"
    },
    Germany: {
      datacenter: "Frankfurt, Germany",
      latency: "GDPR Compliant EU hosting",
      compliance: "GDPR & EU Data Protection",
      network: "European Backbone Network"
    },
    India: {
      datacenter: "Noida, India",
      latency: "Fastest for Indian users",
      compliance: "Local Data Residency",
      network: "Premium Indian Network"
    }
  };
  
  // Location-specific pricing (in local currency)
  export const locationPricing = {
    USA: {
      currency: "$",
      plans: {
        "NVME-1": "12.99",
        "NVME-2": "24.99",
        "NVME-3": "49.99",
        "NVME-4": "89.99",
        "NVME-5": "149.99",
        "NVME-6": "249.99"
      }
    },
    Singapore: {
      currency: "S$",
      plans: {
        "NVME-1": "18.99",
        "NVME-2": "32.99",
        "NVME-3": "64.99",
        "NVME-4": "119.99",
        "NVME-5": "199.99",
        "NVME-6": "329.99"
      }
    },
    Germany: {
      currency: "€",
      plans: {
        "NVME-1": "8.00",
        "NVME-2": "12.00",
        "NVME-3": "16.00",
        "NVME-4": "24.00",
        "NVME-5": "32.00",
        "NVME-6": "48.00"
      }
    },
    India: {
      currency: "₹",
      plans: {
        "NVME-1": "399.00",
        "NVME-2": "699.00",
        "NVME-3": "1299.00",
        "NVME-4": "1999.00",
        "NVME-5": "2999.00",
        "NVME-6": "3999.00"
      }
    }
  };
  
  // Location-specific hardware specifications
  export const locationSpecs = {
    USA: {
      "NVME-1": {
        cpu: "2 Core @ 2.5 GHz",
        benchmark: "Benchmark 580",
        ram: "4 GB",
        ramMax: "up to 64GB",
        storage: "40GB NVME SSD",
        storageMax: "up to 1TB disk",
        bandwidth: "10Gbps",
        traffic: "20TB/mo free traffic",
        ips: "1",
        ipsMax: "up to 3"
      },
      "NVME-2": {
        cpu: "4 Core @ 2.5 GHz",
        benchmark: "Benchmark 580",
        ram: "8 GB",
        ramMax: "up to 64GB",
        storage: "80GB NVME SSD",
        storageMax: "up to 1TB disk",
        bandwidth: "10Gbps",
        traffic: "20TB/mo free traffic",
        ips: "1",
        ipsMax: "up to 3"
      },
      "NVME-3": {
        cpu: "8 Core @ 2.5 GHz",
        benchmark: "Benchmark 580",
        ram: "16 GB",
        ramMax: "up to 64GB",
        storage: "160GB NVME SSD",
        storageMax: "up to 1TB disk",
        bandwidth: "10Gbps",
        traffic: "20TB/mo free traffic",
        ips: "1",
        ipsMax: "up to 3"
      },
      "NVME-4": {
        cpu: "16 Core @ 2.5 GHz",
        benchmark: "Benchmark 580",
        ram: "32 GB",
        ramMax: "up to 64GB",
        storage: "320GB NVME SSD",
        storageMax: "up to 1TB disk",
        bandwidth: "10Gbps",
        traffic: "20TB/mo free traffic",
        ips: "1",
        ipsMax: "up to 3"
      },
      "NVME-5": {
        cpu: "20 Core @ 2.5 GHz",
        benchmark: "Benchmark 580",
        ram: "32 GB",
        ramMax: "up to 64GB",
        storage: "400GB NVME SSD",
        storageMax: "up to 1TB disk",
        bandwidth: "10Gbps",
        traffic: "20TB/mo free traffic",
        ips: "1",
        ipsMax: "up to 3"
      },
      "NVME-6": {
        cpu: "24 Core @ 2.5 GHz",
        benchmark: "Benchmark 580",
        ram: "64 GB",
        ramMax: "up to 64GB",
        storage: "480GB NVME SSD",
        storageMax: "up to 1TB disk",
        bandwidth: "10Gbps",
        traffic: "20TB/mo free traffic",
        ips: "1",
        ipsMax: "up to 3"
      }
    },
    Singapore: {
        "NVME-1": {
            cpu: "2 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "4 GB",
            ramMax: "up to 32GB",
            storage: "40GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-2": {
            cpu: "4 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "8 GB",
            ramMax: "up to 32GB",
            storage: "80GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-3": {
            cpu: "8 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "16 GB",
            ramMax: "up to 32GB",
            storage: "160GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-4": {
            cpu: "16 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "32 GB",
            ramMax: "up to 32GB",
            storage: "320GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-5": {
            cpu: "20 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "32 GB",
            ramMax: "up to 32GB",
            storage: "400GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-6": {
            cpu: "24 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "32 GB",
            ramMax: "up to 32GB",
            storage: "480GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          }
    },
    Germany: {
        "NVME-1": {
            cpu: "2 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "4 GB",
            ramMax: "up to 32GB",
            storage: "40GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-2": {
            cpu: "4 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "8 GB",
            ramMax: "up to 32GB",
            storage: "80GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-3": {
            cpu: "8 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "16 GB",
            ramMax: "up to 32GB",
            storage: "160GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-4": {
            cpu: "16 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "32 GB",
            ramMax: "up to 32GB",
            storage: "320GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-5": {
            cpu: "20 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "32 GB",
            ramMax: "up to 32GB",
            storage: "400GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-6": {
            cpu: "24 Core @ 2.5 GHz",
            benchmark: "Benchmark 580",
            ram: "32 GB",
            ramMax: "up to 32GB",
            storage: "480GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "10Gbps",
            traffic: "20TB/mo free traffic",
            ips: "1",
            ipsMax: "up to 3"
          }
    },
    India: {
        "NVME-1": {
            cpu: "2 Core @ 2.30 GHz",
            benchmark: "Benchmark 2,800",
            ram: "4 GB",
            ramMax: "up to 64GB",
            storage: "50GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "1Gbps",
            traffic: "Unlimited Bandwidth",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-2": {
            cpu: "4 Core @ 2.30 GHz",
            benchmark: "Benchmark 5,600",
            ram: "8 GB",
            ramMax: "up to 64GB",
            storage: "100GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "1Gbps",
            traffic: "Unlimited Bandwidth",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-3": {
            cpu: "8 Core @ 2.30 GHz",
            benchmark: "Benchmark 11,200",
            ram: "16 GB",
            ramMax: "up to 64GB",
            storage: "200GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "1Gbps",
            traffic: "Unlimited Bandwidth",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-4": {
            cpu: "16 Core @ 2.30 GHz",
            benchmark: "Benchmark 17,600",
            ram: "24 GB",
            ramMax: "up to 64GB",
            storage: "400GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "1Gbps",
            traffic: "Unlimited Bandwidth",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-5": {
            cpu: "20 Core @ 2.30 GHz",
            benchmark: "Benchmark 22,000",
            ram: "32 GB",
            ramMax: "up to 64GB",
            storage: "600GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "1Gbps",
            traffic: "Unlimited Bandwidth",
            ips: "1",
            ipsMax: "up to 3"
          },
          "NVME-6": {
            cpu: "24 Core @ 2.30 GHz",
            benchmark: "Benchmark 26,400",
            ram: "64 GB",
            ramMax: "up to 64GB",
            storage: "800GB NVME SSD",
            storageMax: "up to 1TB disk",
            bandwidth: "1Gbps",
            traffic: "Unlimited Bandwidth",
            ips: "1",
            ipsMax: "up to 3"
          }
    }
  };
